<div class="container">
  <h2 class="mt-4 mb-4">Vendor Management</h2>

  <!-- Add Supplier Form -->
  <div class="card mb-4" *ngIf="showSupplierForm">
    <div class="card-body">
      <h4>Add New Supplier</h4>
      <form (ngSubmit)="createSupplier()">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Name *</label>
              <input type="text" class="form-control" [(ngModel)]="supplierForm.name" name="supplierName" required>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Email *</label>
              <input type="email" class="form-control" [(ngModel)]="supplierForm.email" name="supplierEmail" required>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Password *</label>
              <input type="password" class="form-control" [(ngModel)]="supplierForm.password" name="supplierPassword" required minlength="6">
              <small class="text-muted">Minimum 6 characters</small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Company Name</label>
              <input type="text" class="form-control" [(ngModel)]="supplierForm.companyName" name="supplierCompanyName">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Phone</label>
              <input type="text" class="form-control" [(ngModel)]="supplierForm.phone" name="supplierPhone">
            </div>
          </div>
        </div>
        <button type="submit" class="btn btn-success me-2" [disabled]="loading">
          {{ loading ? 'Creating...' : 'Create Supplier' }}
        </button>
        <button type="button" class="btn btn-secondary" (click)="cancelSupplierForm()">Cancel</button>
        <div *ngIf="error" class="alert alert-danger mt-3">{{ error }}</div>
        <div *ngIf="success" class="alert alert-success mt-3">{{ success }}</div>
      </form>
    </div>
  </div>

  <!-- Add Manager Form -->
  <div class="card mb-4" *ngIf="showManagerForm">
    <div class="card-body">
      <h4>Add New Procurement Manager</h4>
      <form (ngSubmit)="createManager()">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Name *</label>
              <input type="text" class="form-control" [(ngModel)]="managerForm.name" name="managerName" required>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Email *</label>
              <input type="email" class="form-control" [(ngModel)]="managerForm.email" name="managerEmail" required>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Password *</label>
              <input type="password" class="form-control" [(ngModel)]="managerForm.password" name="managerPassword" required minlength="6">
              <small class="text-muted">Minimum 6 characters</small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Phone</label>
              <input type="text" class="form-control" [(ngModel)]="managerForm.phone" name="managerPhone">
            </div>
          </div>
        </div>
        <button type="submit" class="btn btn-success me-2" [disabled]="loading">
          {{ loading ? 'Creating...' : 'Create Manager' }}
        </button>
        <button type="button" class="btn btn-secondary" (click)="cancelManagerForm()">Cancel</button>
        <div *ngIf="error" class="alert alert-danger mt-3">{{ error }}</div>
        <div *ngIf="success" class="alert alert-success mt-3">{{ success }}</div>
      </form>
    </div>
  </div>

  <!-- Suppliers Section -->
  <div class="card mb-4">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4>All Suppliers</h4>
        <button class="btn btn-primary" (click)="showAddSupplierForm()" *ngIf="!showSupplierForm">
          + Add Supplier
        </button>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Company Name</th>
            <th>Phone</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let supplier of suppliers">
            <td>{{ supplier.name }}</td>
            <td>{{ supplier.email }}</td>
            <td>{{ supplier.companyName || '-' }}</td>
            <td>{{ supplier.phone || '-' }}</td>
            <td>
              <span class="badge" [ngClass]="supplier.isActive ? 'badge-success' : 'badge-danger'">
                {{ supplier.isActive ? 'Active' : 'Inactive' }}
              </span>
            </td>
          </tr>
          <tr *ngIf="suppliers.length === 0">
            <td colspan="5" class="text-center text-muted">No suppliers found</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Procurement Managers Section -->
  <div class="card">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4>Procurement Managers</h4>
        <button class="btn btn-primary" (click)="showAddManagerForm()" *ngIf="!showManagerForm">
          + Add Manager
        </button>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let manager of managers">
            <td>{{ manager.name }}</td>
            <td>{{ manager.email }}</td>
            <td>{{ manager.phone || '-' }}</td>
            <td>
              <span class="badge" [ngClass]="manager.isActive ? 'badge-success' : 'badge-danger'">
                {{ manager.isActive ? 'Active' : 'Inactive' }}
              </span>
            </td>
          </tr>
          <tr *ngIf="managers.length === 0">
            <td colspan="4" class="text-center text-muted">No procurement managers found</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

